import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskModule } from './ngx-mask';
import { PrimengModule } from '@modules/primeng/primeng.module';

/**
 * this just a shortcut module for commonly used modules 🚀.
 *
 */
@NgModule({
	exports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, NgxMaskModule, PrimengModule],
})
export class SmartyModule {}
